import PropTypes from "prop-types";

const clearFlashingFeaturesLayer = (map, prefix) => {
  const prefixLayers = map
    .getLayers()
    .getArray()
    .filter((l) => l.getClassName().match(new RegExp(`^${prefix}`)));
  if (prefixLayers.length > 0) {
    prefixLayers.forEach((layer) => {
      map.removeLayer(layer);
      layer.getSource().clear();
    });
  }
};

clearFlashingFeaturesLayer.defaultProps = {
  map: null,
  prefix: "",
};

clearFlashingFeaturesLayer.propTypes = {
  map: PropTypes.oneOfType([PropTypes.any]),
  prefix: PropTypes.string,
};
export default clearFlashingFeaturesLayer;
